<template>
  <div class="turn-book" @click="clickEmit">
    <div class="img" :style="{ backgroundImage: `url(${img})` }" v-show="!isText"></div>
    <div class="text" v-show="isText" v-html="readText"></div>
    <div class="pager"></div>
  </div>
</template>

<script>
import { getSearchParams } from '@/utils'
import baseConfig from '@/config'
import { EasyScroller } from 'easyscroller'
const reader = new FileReader()
function getFileFromUrl (url) {
  return new Promise(async (resolve, reject) => {
    const response = await fetch(url)
    const blob = await response.blob()
    let file = new File([blob], 'test', { type: blob.type })
    resolve(file)
  })
}
let scroller = null
export default {
  data () {
    return {
      img: 'http://192.168.0.135:8047/mlibrary-data/105410005/105410005_001/TIFF/0001.jpg',
      readText: '',
      sourceId: getSearchParams(window.location.href).sourceId,
      coverPrefix: baseConfig.coverPrefix,
      height: window.innerHeight
    }
  },
  props: {
    pages: Array,
    curPage: Number,
    isText: Boolean
  },
  methods: {
    async getPage (page) {
      let url = `${this.coverPrefix}/${this.sourceId.split('_')[0]}/${this.sourceId}/单版TXT/` + String(page).padStart(4, '0') + '.txt'
      let file = await getFileFromUrl(url)
      // reader.readAsText(file, 'UTF-8')
      reader.readAsText(file, 'GB2312')
    },
    clickEmit () {
      this.$emit('click')
    },
    creteScroll () {
      const scrollContent = document.querySelector('.img')
      scroller = new EasyScroller(scrollContent, {
        scrollingX: true,
        scrollingY: true,
        zooming: true,
        minZoom: 1,
        maxZoom: 4.0,
        zoomLevel: 1
      })
    }
  },
  mounted () {
    reader.onload = e => {
      this.readText = e.target.result.replaceAll(/\n|\r\n/g, '<br/>')
    }
    document.querySelector('.turn-book').addEventListener('copy', e => {
      e.preventDefault()
    })
    document.querySelector('.turn-book').addEventListener('contextmenu', e => {
      e.preventDefault()
    })
    this.creteScroll()
  },
  watch: {
    pages (val) {
      let url = val[0].url
      this.img = this.coverPrefix + url
      // this.getPage(1)
    },
    curPage (page) {
      this.img = this.coverPrefix + this.pages[page - 1].url
      this.getPage(page)
    },
    isText (val) {
      if (val) {
        scroller.destroy()
      } else {
        this.creteScroll()
      }
    }
  },
  beforeDestroy () {
    if (scroller) {
    }
    // scroller.destroy()
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.turn-book {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .img {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-size: 95% auto;
    background-repeat: no-repeat;
  }
  .text {
    width: 75%;
    height: 80%;
    // text-indent: 2em;
    font-size: 48px;

    font-weight: 600;
    display: flex;
    // align-items: center;
    justify-content: center;
    // padding: 64px 48px;
    // writing-mode: vertical-rl;
    // text-orientation: upright;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
